import { render, staticRenderFns } from "./RouterList.vue?vue&type=template&id=63fcbc16&scoped=true"
import script from "./RouterList.vue?vue&type=script&lang=js"
export * from "./RouterList.vue?vue&type=script&lang=js"
import style0 from "./RouterList.vue?vue&type=style&index=0&id=63fcbc16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fcbc16",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmImg: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmImg.vue').default})
